/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description User context with the profile
 * Hook for creating links inside the app
 *
 * @evaluation good
 * @category Context providers
 *
 */
import { UserInfo } from "@qpr/client-library";
import React from "react";
type Profile = {
  profile?: {
    _id: string;
    meaLogonName: string;
    meaUserId: string;
    fullName: string;
    email: string;
    organization: string;
    role: string;
    uiRole: string;
    /** Array of MEA group names (e.g. ['L1_01', 'L2_03']) synced from backend on login. */
    roles?: string[];
    landingUrl: string;
    landingTitle: string;
    createdAt: {
      $date: string;
    };
    lastLoginAt: string;
    logins: number;
    tenantAdmin: boolean;
    superAdmin?: boolean;
    adminTools?: string[];
  };
};
export const UserContext = React.createContext({} as UserInfo & Profile);
export default () => React.useContext(UserContext);
